.container {
  position: relative;
}

.input-container {
  display: flex;
  align-items: center;
}

.input-inner-container {
  border-right: solid 1px var(--calendar-border);
  margin-right: 5px;
}

.input {
  border: 0;
  padding: 5px 6px;
  background-color: white;
  box-sizing: border-box;
  color: var(--button-text);
  width: 100%;
}

.img-container {
  width: 20px;
  display: flex;
  margin-right: 5px;
}

.img-container svg {
  fill: var(--main-text);
  cursor: pointer;
}

.picker-container {
  user-select: none;
  position: absolute;
  background-color: white;
  box-shadow: 4px 4px 30px 0 rgb(0 0 0 / 20%);
  z-index: 10;
}
